export const FETCH_BANNER_CONTAINER_START = 'FETCH_BANNER_CONTAINER_START';
export const FETCH_BANNER_CONTAINER_SUCCESS = 'FETCH_BANNER_CONTAINER_SUCCESS';
export const FETCH_BANNER_CONTAINER_FAILURE = 'FETCH_BANNER_CONTAINER_FAILURE';
